export * from './segmento-contrato.pipe';
